import { UserService, ProjectConfigService } from '../modules';
export default class Resolver {
    static async resolve() {
        try {
            await UserService.resolve();
            await ProjectConfigService.resolve();
        }
        catch (err) { }
    }
}
